// src/routes/usersRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Users from '../pages/users/Users';
import CreateUser from '../pages/users/CreateUser';
import EditUser from '../pages/users/EditUser';
import ProtectedRoute from '../components/global/ProtectedRoute';

const usersRoutes = (
    <>
        {/* Users List */}
        <Route
            path="/users"
            element={
                <ProtectedRoute requiredPermission="viewAny-user">
                    <Users />
                </ProtectedRoute>
            }
        />

        {/* Create User */}
        <Route
            path="/users/create"
            element={
                <ProtectedRoute requiredPermission="create-user">
                    <CreateUser />
                </ProtectedRoute>
            }
        />

        {/* Edit User */}
        <Route
            path="/users/:id/edit"
            element={
                <ProtectedRoute requiredPermission="update-user">
                    <EditUser />
                </ProtectedRoute>
            }
        />
    </>
);

export default usersRoutes;